import { render, staticRenderFns } from "./AreaStackChart.vue?vue&type=template&id=51fa5e45"
import script from "./AreaStackChart.vue?vue&type=script&lang=js"
export * from "./AreaStackChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports